
  import { Vue, Component, Prop, Model } from "vue-property-decorator";
  import ADD_TO_DISABLED_NOTIFICATIONS_LIST from "@/apollo/company/AddToDisabledNotificationsList.gql";
  import REMOVE_FROM_DISABLED_NOTIFICATIONS_LIST from "@/apollo/company/RemoveFromDisabledNotificationsList.gql";

  import UIButton from "@/components/button/ui-button.vue";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";

  @Component({
    components: {
      UIButton,
    },
  })
  export default class CompanyNotificationsButton extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, default: undefined }) readonly buttonVariant?: string;
    @Model("toggle", { type: Boolean }) readonly notificationsDisabled!: boolean;

    processing: boolean = false;

    get buttonText(): string {
      return this.notificationsDisabled 
        ? "Enable notifications" 
        : "Disable notifications";
    }

    async toggleCompanyNotifications(): Promise<void> {
      this.processing = true;
      try {
        if (this.notificationsDisabled) {
          await this.enableNotifications();
          this.$emit('toggle', false);
        } else {
          await this.disableNotifications();
          this.$emit('toggle', true);  
        }
      } catch (e) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
      } finally {
        this.processing = false;
      }
    }

    private disableNotifications() {
      return this.$apollo.mutate({
        mutation: ADD_TO_DISABLED_NOTIFICATIONS_LIST,
        variables: {
          userId: this.currentUserId,
          companyId: this.companyId,
        },
      });
    }

    private enableNotifications() {
      return this.$apollo.mutate({
        mutation: REMOVE_FROM_DISABLED_NOTIFICATIONS_LIST,
        variables: {
          userId: this.currentUserId,
          companyId: this.companyId,
        },
      });
    }
  }
